import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('useUserRoles');

    return {
        FETCHING_USER_ROLES_ERROR_MESSAGE: t('fetchingUserRolesError'),
        UPDATING_USER_ROLES_SUCCESS_MESSAGE: t('updatingUserRolesSuccess')
    };
};

export default useTranslation;
